import { Home, CalendarDays, Trophy, Shield, UsersRound, Medal, ArrowLeftRight, Swords, Globe2, Activity, Sparkles, Layers3, Radio, Newspaper, Instagram, Ticket, Settings, Clapperboard } from 'lucide-react';

export const clubManagementLink = { to: '/gestion-club', label: 'Gestion du club', hint: 'Coach, conseil, objectifs, stade, supporters, effectif et carrière', icon: Shield };
export const clubShortcuts = [
  { to: '/gestion-club?onglet=equipe', label: 'Mon effectif', hint: 'Joueurs et compositions au club', icon: UsersRound },
  { to: '/gestion-club?onglet=carriere', label: 'Ma carrière', hint: 'Conseil, objectifs et parcours', icon: Sparkles },
];

export const navigationGroups = [
  { id: 'season', label: 'La compétition', caption: 'Chaque point compte.', color: '#aaa4ff', links: [
    { to: '/competitions', label: 'Compétitions', hint: 'Calendriers, classements et buteurs', icon: Trophy },
    { to: '/clubs', label: 'Tous les clubs', hint: 'Pays, championnats et effectifs', icon: Shield },
    { to: '/classement-coachs', label: 'Classement des coachs', hint: 'La course aux premières places', icon: UsersRound },
    { to: '/recompenses', label: 'Récompenses', hint: 'Votes, distinctions et palmarès', icon: Medal },
    { to: '/coefficient-uefa', label: 'Coefficient UEFA', hint: 'Le classement européen des pays', icon: Globe2 },
    { to: '/indice-puissance', label: 'Forme des clubs', hint: 'Les équipes en forme du moment', icon: Activity },
  ] },
  { id: 'career', label: 'Ton club & ta carrière', caption: 'Toutes tes décisions au même endroit.', color: '#68dfbe', links: [
    { to: '/matchs', label: 'Mes matchs', hint: 'Organiser, jouer et confirmer', icon: CalendarDays },
    clubManagementLink,
    { to: '/mercato-coach', label: 'Mercato coach', hint: 'Trouver ton prochain banc', icon: ArrowLeftRight },
    { to: '/rivalites', label: 'Rivalités', hint: 'Derbys, classicos et confrontations', icon: Swords },
  ] },
  { id: 'community', label: 'Au-delà du terrain', caption: 'La carrière ne s’arrête jamais.', color: '#f2c879', links: [
    { to: '/destins?onglet=tribune', label: 'La Tribune Destins', hint: 'Les histoires publiques des coachs', icon: Sparkles },
    { to: '/fantasy', label: 'Fantasy', hint: 'Ta collection, ton équipe, tes enchères', icon: Layers3 },
    { to: '/pronostics', label: 'Pronostics', hint: 'Coupons et euros fictifs', icon: Activity },
    { to: '/tv', label: 'DayOne TV', hint: 'Directs, multiplex et replays', icon: Radio },
    { to: '/tv/studio', label: 'Mon studio TV', hint: 'Programmer et diffuser un match', icon: Clapperboard },
    { to: '/medias', label: 'Médias', hint: 'Journal, actualités et conférences', icon: Newspaper },
    { to: '/instagram', label: 'Instagram', hint: 'La vie des clubs en images', icon: Instagram },
  ] },
];
export const accountLinks = [
  { to: '/profil', label: 'Mon profil', hint: 'Compte et préférences', icon: Settings },
  { to: '/tickets', label: 'Tickets & aide', hint: 'Contacter le support', icon: Ticket },
];
export const homeLink = { to: '/', label: 'Accueil', icon: Home };
export const allNavigationLinks = [homeLink, ...navigationGroups.flatMap(group => group.links), ...accountLinks];
export function isNavigationActive(pathname, to) {
  to = to.split(/[?#]/)[0];
  if (pathname === to) return true;
  if (to === '/' || to === '/mon-club') return false;
  if (to === '/tv') return pathname.startsWith('/tv/') && pathname !== '/tv/studio';
  return pathname.startsWith(to + '/');
}
export function pageIdentity(pathname) {
  if (pathname === '/destins' || pathname.startsWith('/destins/')) return { ...allNavigationLinks.find(link => link.to === '/destins?onglet=tribune'), label: 'Destins' };
  const exact = allNavigationLinks.find(link => link.to.split(/[?#]/)[0] === pathname);
  if (exact) return exact;
  const aliases = { coaches: '/classement-coachs', joueurs: '/clubs', tirage: '/competitions', journal: '/medias', actualites: '/medias', 'mon-club': '/gestion-club', destins: '/destins?onglet=tribune' };
  const parent = aliases[pathname.split('/')[1]];
  return allNavigationLinks.find(link => link.to === parent) || [...allNavigationLinks].sort((a,b) => b.to.length - a.to.length).find(link => link.to !== '/' && pathname.startsWith(link.to + '/')) || homeLink;
}
export const normalizeNavigation = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

